export const setHeaderHeight = (entry: ResizeObserverEntry): void => {
	const cr = entry.borderBoxSize;
	const headerHeight = cr[0].blockSize;
	if (headerHeight > 0) {
		(document.querySelector(':root') as HTMLElement).style.setProperty(
			`--${'header-height'}`,
			`${headerHeight - 1}px`
		);
	}
};
